import React from 'react';
import ReactDOM from 'react-dom';

import Voting from '../../../react/components/Voting/Voting';

const initVoting = voting => {
    if (!voting.id) return;
    const element = document.querySelector(`[data-voting="${voting.id}"]`);
    if (!element) return;

    ReactDOM.render(<Voting voting={voting} />, element);
};

export { initVoting };
